import { render, staticRenderFns } from "./MyMenus.vue?vue&type=template&id=1b55dbb0&scoped=true"
import script from "./MyMenus.vue?vue&type=script&lang=js"
export * from "./MyMenus.vue?vue&type=script&lang=js"
import style0 from "./MyMenus.vue?vue&type=style&index=0&id=1b55dbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55dbb0",
  null
  
)

export default component.exports